import styled from 'styled-components';

export const StyledPageTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  overflow: hidden;

  .page-title-prefix,
  .page-title-main,
  .page-title-suffix {
    font-size: ${({ theme }) => theme.font.size.title || '26px'};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.palette.text.primary};
    line-height: 1.5;
  }

  .page-title-main {
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.palette.text.secondary};
  }

  .page-title-separator {
    font-size: ${({ theme }) => theme.font.size.title || '26px'};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.palette.text.primary};
    line-height: 1.5;
  }
`;
